angular.module('mtic.components.user_box', [

])

angular.module('mtic.components.user_box').component('userBox', {
  templateUrl: 'template.html',
  bindings: {
    user: '<'
  },
  controllerAs: 'info',
  controller: function() {
  }
});
